import { useState } from 'react';
import { useMutation } from 'react-query';
import { assetsClipRenameClipPartialUpdate, AssetsClipRenameClipPartialUpdateProps } from '@goldcast/api/content';
import { Clip } from '@/player-config/src/types/clip-types';

import { updateClipInList, updateClipWithId } from '@/stores/clip';
import { showErrorToast } from '@/libs/toast/toast';

export const useClipTitleRename = () => {
  const [renamingClip, setRenamingClip] = useState<Clip | null>(null);
  const closeRenamingClipDialog = () => {
    setRenamingClip(null);
  };
  const { mutate: updateClipTitle } = useMutation(assetsClipRenameClipPartialUpdate, {
    onError: () => showErrorToast("Oops! Couldn't rename the asset. Please try again.")
  });

  const onSaveNewTitle = (newTitle: string) => {
    if (!renamingClip) {
      return;
    }

    if (renamingClip.title !== newTitle) {
      // @kashish TODO - any is used here because Clip and AssetList types are clashing. We should use AssetList instead of Clip everywhere
      updateClipTitle({
        body: {
          asset_id: renamingClip.id,
          title: newTitle
        }
      } as AssetsClipRenameClipPartialUpdateProps);
      const assetMetadata = renamingClip.asset_metadata;
      const updatedClip: Clip = {
        ...renamingClip,
        title: newTitle,
        asset_metadata: assetMetadata
      };
      updateClipWithId(renamingClip.id, updatedClip, false, true);
      updateClipInList(updatedClip);
    }

    closeRenamingClipDialog();
  };

  return {
    renamingClip,
    onSaveNewTitle,
    closeRenamingClipDialog,
    setRenamingClip
  };
};
